import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import QcImpactAnalysisPage from "./qc-impact-analysis.page";
import { getLang } from "app/feature/constants";
import CreditReportingApi from "../../../../app/api/credit-reporting";

export default function QcImpactAnalysisContainer() {
    const lang = useSelector((state) => state.constant.languages);

    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 25,
    });

    const [listingData, setListingData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    const fetchData = () => {
        setIsLoading(true);
        setIsError(false);
        CreditReportingApi.fetchQcEventHistory({
            start: pagination.page * pagination.rowsPerPage,
            length: pagination.rowsPerPage,
        }).then((response) => {
            setIsLoading(false);
            setListingData(response.data);
        }).catch(() => {
            setIsLoading(false);
            setIsError(true);
        });
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination]);

    const translate = (text) => {
        return getLang(lang, text);
    };

    const handlePageChange = (page) => {
        setPagination((prev) => ({
            ...prev,
            page: page,
        }));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({
            page: 0,
            rowsPerPage: rowsPerPage,
        });
    };

    return (
        <QcImpactAnalysisPage
            translate={translate}
            listingData={listingData}
            pagination={pagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            isLoading={isLoading}
            isError={isError}
            handleReload={fetchData}
        />
    );
}
